import styled from 'styled-components';
import { largeFontSize, FontWeight, Spacing } from 'modules/styles/variables';
import { textLight } from 'modules/styles/colors';
import Modal from '@material-ui/core/Modal';

export const Subtitle = styled.span`
  font-weight: ${FontWeight.bold};
  font-size: ${largeFontSize};
  color: ${textLight};
  margin-right: ${Spacing.medium}px;
`;

export const TooltipModal = styled(Modal)`
  width: 18rem;
  position: absolute;
  margin: auto;
`;

export const TooltipInside = styled.div`
  padding: 1rem;
  margin-top: 50%;
  border: 1px solid #000000;
  background-color: white;
  && > p {
    font-weight: 100;
    font-size: 14px;
  }
`;

export const RightDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: -1rem;
`;
